export default __webpack_public_path__ + "static/media/home03.bd6b4206.png";